import React from 'react';

function DateToWords({ date }) {
  const convertDateToWords = (dateString) => {
    const months = [
      '',
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ];

    const [month, day, year] = dateString.split('/');

    const dayInWords = getDayInWords(parseInt(day, 10));
    const monthInWords = months[parseInt(month, 10)];
    const yearInWords = getYearInWords(parseInt(year, 10));

    return `${dayInWords} ${monthInWords} ${yearInWords}`;
  };

  const getDayInWords = (day) => {
    const daySuffixes = [
      'th',
      'st',
      'nd',
      'rd',
      'th',
      'th',
      'th',
      'th',
      'th',
      'th',
      'th',
      'th',
      'th',
      'th',
      'th',
      'th',
      'th',
      'th',
      'th',
      'th',
      'st',
      'nd',
      'rd',
      'th',
      'th',
      'th',
      'th',
      'th',
      'th',
      'th',
      'th',
      'st'
    ];

    if (day >= 1 && day <= 31) {
      if (day <= 31 && day >= 4 && day <= 20) {
        return `${day}${daySuffixes[0]}`;
      } else {
        const lastDigit = day % 10;
        return `${day}${daySuffixes[lastDigit]}`;
      }
    } else {
      return '';
    }
  };

  const getYearInWords = (year) => {
    const numberWords = [
      '',
      'one',
      'two',
      'three',
      'four',
      'five',
      'six',
      'seven',
      'eight',
      'nine',
      'ten',
      'eleven',
      'twelve',
      'thirteen',
      'fourteen',
      'fifteen',
      'sixteen',
      'seventeen',
      'eighteen',
      'nineteen'
    ];

    const tensWords = [
      '',
      '',
      'twenty',
      'thirty',
      'forty',
      'fifty',
      'sixty',
      'seventy',
      'eighty',
      'ninety'
    ];

    if (year >= 1 && year <= 9999) {
      if (year >= 1000) {
        const thousands = Math.floor(year / 1000);
        const hundreds = Math.floor((year % 1000) / 100);
        const tens = Math.floor((year % 100) / 10);
        const ones = year % 10;

        let result = '';

        if (thousands > 0) {
          result += `${numberWords[thousands]} thousand `;
        }

        if (hundreds > 0) {
          result += `${numberWords[hundreds]} hundred `;
        }

        if (tens > 0 || ones > 0) {
          if (tens === 1) {
            result += `${numberWords[tens * 10 + ones]} `;
          } else {
            result += `${tensWords[tens]} ${numberWords[ones]} `;
          }
        }

        return result.trim();
      } else {
        return numberWords[year];
      }
    } else {
      return '';
    }
  };

  const words = convertDateToWords(date);

  return <div>{words}</div>;
}

export default DateToWords;
